module.exports = __webpack_public_path__ + "img/17-bg.1ac125df.jpg";